<div>
  @if (form) {
    <div class="row-with-title" *let="isWorkspaceCreating$ | async as creating">
      <div class="col-title">
        {{ 'workspaces.myWorkspaces' | transloco }}
      </div>

      <div class="col-add-button">
        @if (canWrite$ | async) {
          <app-button
            class="after-control"
            icon="add"
            [type]="btnTypes.Flat"
            label="{{ 'workspaces.createWorkspace' | transloco }}"
            (onClick)="addWorkspace()"
            [disabled]="!!creating"
            [size]="btnSizes.Basic"
          ></app-button>
        }
      </div>
    </div>

    <div [formGroup]="form">
      <div class="row-adaptive filters">
        <div class="col-adaptive main-filter-col">
          <app-search-input
            placeholder="{{ 'placeholders.filterByWorkspaceName' | transloco }}"
            formControlName="workspaceName"
            class="filter-control"
          ></app-search-input>
        </div>
      </div>
    </div>
  }

  @if (dataRecieved && form) {
    <div class="workspaces-page__table-region">
      <app-workspaces-list></app-workspaces-list>
    </div>
  }
</div>
